module.exports = __webpack_public_path__ + "static/img/ss07.f735bbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/rickle/ss07.png
// module id = CYQP
// module chunks = 0